import Helpers from './Helpers.js'
import LoggedInUser from './LoggedInUser.js'

class User {

    profileTypes = [
        'Female Model',
        'Male Model',
        'Photographer',
        'Casting Director',
        'Creative Director',
        'Designer',
        'E-Commerce Manager',
        'Hair Stylist',
        'Hand / Foot Model',
        'Influencer',
        'Make-up Artist',
        'Manicurist',
        'Other',
        'Producer',
        'Prop Stylist',
        'Rental Studio',
        'Retoucher',
        'Studio Manager',
        'Stylist',
        'Videographer'
    ];

    constructor(params) {
        Object.keys(params).forEach(function(attr) {
            this[attr] = params[attr];
        }.bind(this));
    }

    isUS() {
        if (!this.country) return false
        const usLabels = ['US', 'USA', 'United States']
        const isUS = usLabels.includes(this.country)
        return isUS
    }

    waitlistColor() {
        if (this.waitlist_entry && this.waitlist_entry.mc_url) {
            return "mdc"; }
        if (this.referrer)
            return 'role-based-referral'
        if (this.lib_referrer_swipecast_id && this.waitlisted && !this.lib_restrictions_applied)
            return 'not-converted-lib'
        if (this.lib_referrer_swipecast_id || this.swipecast_offer_id)
            return "referrer";
        if (this.instagram_followers > 10000) {
            return "ig"; }
        if (this.isUS() && this.is_company_email) {
            return 'us-co'
        }
        return "";
    }

    profileImage(size = 400) {
        let image = null;
        if (this.profile_image) { image = Helpers.imageURL(this.profile_image, size) }
        return (image || Helpers.defaultThumbnail);
    }

    phone() {
        let phone = this.phone_number;
        if (this.phone_country_code) {
            phone = "+" + this.phone_country_code + ' ' + this.phone_number;
        }
        return (phone || 'N/A');
    }

    signUpDate() {
        return new Date(Date.parse(this.created_at)).toISOString().slice(0, 10);
    }

    waitlistCompletion() {
        if (this.waitlist_entry.completion == 'partiallyComplete') {
            return 'Partially Complete' }
        return this.waitlist_entry.completion.charAt(0).toUpperCase() + this.waitlist_entry.completion.slice(1);
    }

    individualProfileText(profile) {
        return profile.profile_type === 'Model'
          ? profile.data.gender + ' ' + profile.profile_type
          : profile.profile_type
    }

    updateWaitlistEntry(params) {
        return fetch(Helpers.endpoint("/update_waitlist_entry"), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(
                Object.assign({}, {
                    auth_token: LoggedInUser.getInfo().auth_token,
                    waitlist_entry: params,
                    swipecast_user_id: this.swipecast_user_id
                })
            )
        })
    }

    letOffWaitlist(mcURL, manualOrdering, admin_id) {
        return fetch(Helpers.endpoint("/off_waitlist"), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(
                Object.assign({}, {
                    auth_token: LoggedInUser.getInfo().auth_token,
                    swipecast_user_id: this.swipecast_user_id,
                    swipecast_admin_id: (admin_id && admin_id !== 'None') ? admin_id : LoggedInUser.getInfo().user.swipecast_user_id,
                    manual_ordering: manualOrdering,
                    mc_url: mcURL
                })
            )
        })
    }
}

export default User;
